import Timeline from "@material-ui/lab/Timeline";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import React from "react";
import styles from "./style.module.css";
import { ReactComponent as DoIcon } from "./icons/do-icon.svg";
import { ReactComponent as PuIcon } from "./icons/pu-icon.svg";


export default React.memo((({ puPoint, doPoint, className }) => {
  const MainAddress = (p) => {
    if (p.airport.name) {
      return `${p.airport.name}, ${p.address.city}`;
    }
    return `${p.address.streetNumber} ${p.address.street}, ${p.address.city}`;
  };
  const SecondaryAddress = (p) => `${p.address.state} ${p.address.zip}, ${p.address.country}`;

  return (
    <Timeline className={className}>
      <TimelineItem className={styles.routePointItem}>
        <TimelineSeparator>
          <PuIcon className={styles.pointIcon} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent className={styles.routePointAddress}>
          <p className={styles.mainAddress}>{MainAddress(puPoint)}</p>
          <p className={styles.secondaryAddress}>{SecondaryAddress(puPoint)}</p>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.routePointItem}>
        <TimelineSeparator>
          <DoIcon className={styles.pointIcon} />
        </TimelineSeparator>
        <TimelineContent className={styles.routePointAddress}>
          <p className={styles.mainAddress}>{MainAddress(doPoint)}</p>
          <p className={styles.secondaryAddress}>{SecondaryAddress(doPoint)}</p>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}));
